export default "__VITE_ASSET__D$TXqHN3__"